import { toast } from 'react-toastify';

import { useLoading } from '@/contextProviders/loadingProvider';
import { InregelingOpdracht, VerwijderInregelingOpdracht } from '@/queries/mutaties/opdrachten';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { toastSuccessOptions } from '@/utils/toastOptions';

export interface Executable {
  url: string;
  body: any;
  onSuccess: string;
  onError: string;
}

export function useInregelen() {
  const { setLoading } = useLoading();
  const { fetchWithAuth } = useFetchWithAuth();

  const execute = async ({ url, body, onSuccess, onError }: Executable) => {
    try {
      setLoading(true);

      const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      const responseData = (await response.json()) as string;

      console.log(`Response voor inregelen:${responseData}`);
      switch (responseData) {
        case 'SUCCES':
          toast.success(onSuccess, toastSuccessOptions);
          break;
        case 'FUNCTIONELE_FOUT_NOT_FOUND':
          toast.error(
            'Mutatie is niet gelukt. (Niet gevonden). Probeer het nog een keer of neem contact op met support.',
            { position: 'top-center' },
          );
          break;
        case 'FUNCTIONELE_FOUT_CONFLICT':
          toast.error(onError, { position: 'top-center' });
          break;
        case 'TECHNISCHE_FOUT':
          toast.error(
            'Mutatie is niet gelukt vanwege een technische fout. Probeer het nog een keer of neem contact op met support.',
            { position: 'top-center' },
          );
          break;
        case 'BMS_CONNECTIE_FOUT':
          toast.error('Er is een BMS connectiefout opgetreden. Neem contact op met support.', {
            position: 'top-center',
          });
          break;
      }

      return responseData as string;
    } catch (error) {
      console.log(error);
      toast.error('Er is een onbekende fout opgetreden. Neem contact op met support.', { position: 'top-center' });
      return { status: 'TECHNISCHE_FOUT', wijzigingen: [] };
    } finally {
      setLoading(false);
    }
  };

  const makenInregelen = async (opdracht: InregelingOpdracht) => {
    const onSuccess = 'Inregeling wordt verwerkt';
    const onError = 'Inregeling is niet gelukt.';
    return execute({
      url: '/inregelingen/makenInregeling',
      body: opdracht,
      onSuccess,
      onError,
    });
  };

  const wijzigenInregeling = async (opdracht: InregelingOpdracht) => {
    const onSuccess = 'Inregeling wordt verwerkt';
    const onError = 'Inregeling is niet gelukt.';
    return execute({
      url: '/inregelingen/wijzigenInregeling',
      body: opdracht,
      onSuccess,
      onError,
    });
  };

  const verwijderenInregeling = async (opdracht: VerwijderInregelingOpdracht) => {
    const onSuccess = 'Inregeling wordt verwijderd';
    const onError = 'Inregeling verwijderen is niet gelukt.';
    return execute({
      url: '/inregelingen/verwijderenInregeling',
      body: opdracht,
      onSuccess,
      onError,
    });
  };

  return {
    makenInregelen,
    wijzigenInregeling,
    verwijderenInregeling,
  };
}
